export function percentStyle() {
  return {
    'number-zero': params =>
      params.value === undefined ||
      params.value === null ||
      Math.abs(params.value) < 0.0001,
    'number-positive': params => params.value > 0,
    'number-negative': params => params.value < 0
  };
}

export function numberStyle() {
  return {
    'number-zero': params =>
      params.value === undefined || params.value === null || params.value === 0,
    'number-positive': params => params.value > 0,
    'number-negative': params => params.value < 0
  };
}

export function clockStyle() {
  return {
    'number-zero': params =>
      params.value === undefined || params.value === null || params.value === 'N',
    'number-negative': params => params.value === 'Y'
  };
}

export function sideStyle() {
  return {
    'number-positive': params =>
      params.data && ['BUY', 'COVR'].includes(params.data.side),
    'number-negative': params =>
      params.data && ['SELL', 'SHRT'].includes(params.data.side)
  };
}

export function statusStyle() {
  return {
    'status-na': params => !params.value,
    'status-fail': params => params.value === 'FAIL',
    'status-skip': params => params.value === 'SKIP',
    'status-pass': params => params.value === 'PASS',
    'status-warn': params => params.value === 'WARN'
  };
}

export function pendingRouteErrorsStyle() {
  return {
    flash: params => params.value,
    keyword: params => !params.value
  };
}
